import React from 'react';
import _ from 'underscore';
import { getGrowthMetrics } from 'actions/ReportingActionCreators';
import Store from 'stores/ReportingStore';
import { Table, Glyphicon, Row, Col } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';

function getStateFromStore(market) {
  return {
    metrics: Store.getMarketGrowthMetrics(market),
    frequentShippers: Store.getFrequentShippers(),
  };
}

class GrowthMetricTable extends React.Component {
  constructor() {
    super();
    this.state = this.getInitialState();
  }

  getInitialState() {
    return {
      loading: true,
      data: {
        metrics: [],
        frequentShippers: [],
      },
    };
  }

  componentDidMount() {
    Store.addChangeListener(this.onChange.bind(this));
    this.getMetrics(this.props);
  }

  componentWillUnmount() {
    Store.removeChangeListener(this.onChange);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.getMetrics(nextProps);
  }

  onChange() {
    this.setState({
      loading: false,
      data: getStateFromStore(this.props.market),
    });
  }

  getMetrics(props) {
    const { filters, market, date } = props;
    let query = _.clone(filters);

    query.market = { [market]: true };

    if (filters.customerType.frequentShipper) {
      query.shipperId = this.state.data.frequentShippers;
    } else {
      delete query.shipperId;
    }

    getGrowthMetrics(date, query);
  }

  render() {
    const { t } = this.props;
    if (this.state.loading) {
      return <p className="lead text-center">{t('LOADING')}</p>;
    }

    const { market, periodName, comparisonPeriodName } = this.props;
    const rows = this.state.data.metrics.map((row, index) => {
      return (
        <tr key={index}>
          <td>{row.metric}</td>
          <td>{row.metricInPeriod}</td>
          <td>{row.metricInComparisonPeriod}</td>
          <td>{row.growthInMetric}</td>
        </tr>
      );
    });

    return (
      <div>
        <Table bordered hover striped className="reporting-table">
          <thead>
            <tr>
              <th>{market === '*' ? t('ALL_MARKETS') : market}</th>
              <th>{periodName}</th>
              <th>{comparisonPeriodName}</th>
              <th>{t('GROWTH')}</th>
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </Table>
      </div>
    );
  }
}
export default withTranslation()(GrowthMetricTable);
